export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-spinner/index.js